<template>
  <div>
    <!-- <v-data-table :headers="headers" :items="wData" :loading="true" class="elevation-1"> -->
    <v-data-table :headers="headers" :items="get_wData" class="elevation-1">
      <template v-slot:items="props">
        <td>{{ props.item.payloadNum }}</td>
        <td class="text-xs-right">{{ props.item.timestamp | moment("MM-DD-YYYY h:mm:ss a") }}</td>
        <td class="text-xs-right">{{ props.item.sensorName }}</td>
        <td class="text-xs-right">{{ props.item.sensorType }}</td>
        <td class="text-xs-right">{{ props.item.deviceId }}</td>
        <td class="text-xs-right">{{ props.item.temperature }}</td>
        <td class="text-xs-right">{{ props.item.humidity }}</td>
        <td class="text-xs-right">{{ props.item.mb }}</td>
      </template>
      <template slot="no-data">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
      </template>
    </v-data-table>
  </div>
</template>




<script>
import WeatherService from "@/services/WeatherService";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      headers: [
        {
          text: "Payload #",
          align: "left",
          sortable: false,
          value: "payloadNum"
        },
        { text: "DateTime", value: "timestamp" },
        { text: "Sensor Name", value: "sensorName" },
        { text: "Sensor Type", value: "sensorType" },
        { text: "Device ID", value: "deviceId" },
        { text: "Temperature", value: "temperature" },
        { text: "Humidity (%)", value: "humidity" },
        { text: "Barometric Pressure (mb)", value: "mb" }
      ]
      // wData: []
    };
  },
  mounted() {
    this.getWData()
      .then(data => {
        this.$store.state.wData = data;
      })
      .then(
        this.getSensors().then(data => {
          this.$store.state.sensors = data;
          // console.log(this.$store.state.sensors);
        })
      )
      .then(() => {
        let d = this.$store.getters.get_wData;
        // console.log(d);
        this.processSensorReadings();
      });
  },
  methods: {
    async getWData() {
      const response = await WeatherService.fetchWeatherData();
      console.log("response", response);
      // this.wData = response.data.wData;
      return response.data;
    },
    async getSensors() {
      const response = await WeatherService.fetchSensors();
      return response.data;
    },
    processSensorReadings: function() {
      return this.$store.dispatch(
        "populateInitialSensorReadings"
        // this.$store.state,
        // this.$store.getters
      );
    }
  },
  computed: {
    ...mapGetters(["get_wData"])
  }
};
</script>